/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { ModalGeneric } from '../ModalGeneric/ModalGeneric';

import styles from './ModalNotification.module.scss';

export type ModalNotificationProps = {
  isOpen: boolean;
  close: () => void;
  theme?: 'success' | 'danger' | 'warning' | 'default';
  header: string;
  message: JSX.Element | string;
  buttonText: string;
  icon?: JSX.Element | string;
  iconPosition?: 'right' | 'left';
  cancelText?: string;
  onCancel?: () => void;
};

export const ModalNotification = ({
  isOpen,
  close,
  theme = 'success',
  header,
  message,
  buttonText,
  icon,
  iconPosition = 'right',
  cancelText,
  onCancel,
}: ModalNotificationProps) => {
  const buttonThemes = {
    success: 'success',
    danger: 'danger',
    default: 'default',
    warning: 'warning',
  };

  const showCancelButton = onCancel && cancelText;

  return (
    <ModalGeneric isOpen={isOpen} close={onCancel ?? close}>
      <div className={styles.content}>
        <span
          className={[
            styles.header,
            styles[`title-${buttonThemes[theme]}`],
          ].join(' ')}
        >
          {iconPosition === 'right' ? (
            <>
              {header} {icon && icon}
            </>
          ) : (
            <>
              {icon && icon} {header}{' '}
            </>
          )}
        </span>
        <p className={styles.message}>{message}</p>
      </div>
      <div className={styles.actions}>
        <button
          onClick={close}
          className={`${styles.button} ${styles[buttonThemes[theme]]}`}
        >
          {buttonText}
        </button>
        {showCancelButton && (
          <button
            onClick={onCancel}
            className={`${styles.button} ${
              styles[`secondary-${buttonThemes[theme]}`]
            }`}
          >
            {cancelText}
          </button>
        )}
      </div>
    </ModalGeneric>
  );
};
